import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import { ClipLoader } from "react-spinners";
import {managerUpdateRequest} from "../store/actions/manager.js";
import OrgData from "../components/Mydata/OrgData.js";
function Profile() {
    const dispatch = useDispatch();
    const myData = useSelector(state => state.manager.employee);
    const duration = useSelector(state => state.task.duration);

    const [state, setState] = useState({
        show: true,
        user: {
            name: "",
            surname: "",
            phone: "",
            email: "",
            document_type: "",
            document_number: ""
        },
        imagePreviewUrl: "",
        all_duration: 0,
        result: []
    });

    useEffect(() => {
        setState(prevState => ({ ...prevState, ...duration }));
    }, [duration]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        const formData = new FormData();
        formData.append("image", file);
        formData.append("user.first_name", myData.user.first_name);
        formData.append("user.last_name", myData.user.last_name);
        formData.append("user.email", myData.user.email);

        reader.onloadend = async () => {
            try {
                await dispatch(managerUpdateRequest({form:formData}));
                // const res = await getEmployeeData(id, token, localStorage.getItem("profession"));
                // dispatch(getEmployeeData(res));
                // setState(prevState => ({ ...prevState, imagePreviewUrl: reader.result }));
            } catch (error) {
                console.error("Error updating image", error);
            }
        };
        reader.readAsDataURL(file);
    };



    return (
        <Wrapper>
            {myData.url?<div className='my-page'>
                <div className='modules-header'/>
                <div className='my-page-cont'>
                    <div className='container'>
                        <Row className='img-name flex-nowrap justify-content-center'>
                            <div className='image-round-name'>
                                <div className='image-round'>
                                    <div className='my-image' style={{ backgroundImage: myData?.image && !state?.file ? `url(${myData?.image})` : null }}>
                                        {state.imagePreviewUrl && <div className='change-my-img' style={{ backgroundImage: `url(${state?.imagePreviewUrl})` }} />}
                                    </div>
                                    <div className='photo-camera-background'>
                                        <label>
                                            <input className="fileInput" type="file" onChange={handleImageChange} />
                                            <div className='photo-camera'/>
                                        </label>
                                    </div>
                                </div>
                                <h1>{myData.user?.first_name} {myData.user?.last_name}</h1>
                            </div>
                        </Row>
                        <OrgData {...{ myData }} />
                        <div className="day-reports">
                            <div>
                                <h5>Օրվա աշխատանքները</h5>
                                <span className="all-tasks">ընդհանուր-{state.all_duration}</span>
                            </div>
                            <div className="table-cont">
                                <div className="table-inside">
                                    {state.result.length > 0 ? (
                                        <table>
                                            <tbody>
                                            <tr>
                                                <th>Կազմակերպության անուն</th>
                                                <th>Առաջադրանքի անուն</th>
                                                <th>Տևողություն</th>
                                            </tr>
                                            {state.result.map((item, index) => (
                                                <tr className='report-list' key={index}>
                                                    <td className='report-item'>{item.company_name}</td>
                                                    <td className='report-item'>{item.task_name}</td>
                                                    <td className='report-item'>{item.duration}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="no-tasks">
                                            <span>Առաջադրանքներ չկան</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>:<div className="loaderMargin">
                <ClipLoader color="#101C2A" size={30} />
            </div>}

        </Wrapper>
    );
}

export default Profile;